import React, { ReactElement } from 'react';
import cc from 'classcat';
import {
  DEFAULT_LAYOUT_ICON_SIZE,
  USA_LAYOUT_ICON_SIZE
} from 'utils/constants/sportsbook/magic-numbers';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

type Props = {
  withBase?: boolean;
  isEvent?: boolean;
  isUsaLayout?: boolean;
  indicatorValue?: string;
};

export const OddIndicator = ({
  indicatorValue,
  withBase,
  isEvent,
  isUsaLayout = false
}: Props): ReactElement => {
  return (
    <GlobalIcon
      lib="generic"
      name={isUsaLayout ? 'arrowIndicator' : 'arrowDown'}
      theme="default"
      size={isUsaLayout ? USA_LAYOUT_ICON_SIZE : DEFAULT_LAYOUT_ICON_SIZE}
      position="absolute"
      className={cc([
        'odd__indicator',
        `odd__indicator--${indicatorValue}`,
        {
          'odd__indicator--usa': isUsaLayout,
          'odd__indicator-withBase': withBase,
          'odd__indicator-isEvent': isEvent
        }
      ])}
    />
  );
};
